module.exports = __webpack_public_path__ + "img/pay-value4.4b133019.png";